const ACTIVITY_LIVE_EVENT_TYPE = 'activity_change';

function parseActivityLiveSseDataLine(line) {
  if (typeof line !== 'string' || !line.startsWith('data:')) return null;
  const raw = line.slice(5).trim();
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

/** Parse SSE lines into { id?, payload } for activity_change events. */
export function parseActivityLiveSseBlock(lines) {
  let id;
  let payload = null;
  for (const line of lines) {
    if (line.startsWith('id:')) {
      id = line.slice(3).trim();
    } else if (line.startsWith('data:')) {
      payload = parseActivityLiveSseDataLine(line);
    }
  }
  if (!payload || payload.type !== ACTIVITY_LIVE_EVENT_TYPE) {
    return null;
  }
  return { id, payload };
}
